export default __webpack_public_path__ + "media/images/rics-dbe20c4e82bd08f032339f0cfcd1e137.svg";